import { IStoreTimingUpdatePayload } from "./interface";

const padTwoDigits = (value: number) => String(value).padStart(2, "0");

export const formatTimeInputValue = (hour: number, minute: number) => `${padTwoDigits(hour)}:${padTwoDigits(minute)}`;

export const format12HourTime = (hour: number, minute: number) =>
  Number.isFinite(hour) && Number.isFinite(minute)
    ? `${padTwoDigits(hour % 12 || 12)}:${padTwoDigits(minute)} ${hour < 12 ? "AM" : "PM"}`
    : "—";

export const getStoreTimingDraft = (openingTime: string, closingTime: string) => {
  const [opening_hour, opening_minute] = openingTime.split(":").map(Number);
  const [closing_hour, closing_minute] = closingTime.split(":").map(Number);
  const payload: IStoreTimingUpdatePayload = { opening_hour, opening_minute, closing_hour, closing_minute };

  if (Object.values(payload).some((value) => !Number.isFinite(value))) {
    return { payload, error: "Opening and closing time are both required." };
  }
  if (closing_hour * 60 + closing_minute <= opening_hour * 60 + opening_minute) {
    return { payload, error: "Closing time must be after opening time." };
  }
  return { payload, error: "" };
};
